import CvnaCategoryName from '~/constants/vdp/cvnaCategoryName';

export const cvnaCategoryNamesSortOrder: CvnaCategoryName[] = [
  CvnaCategoryName.performanceAndDrive,
  CvnaCategoryName.comfortAndConvenience,
  CvnaCategoryName.entertainmentAndTechnology,
  CvnaCategoryName.safetyAndSecurity,
  CvnaCategoryName.seatingAndInterior,
  CvnaCategoryName.roofAndGlass,
  CvnaCategoryName.cargoAndTowing,
  CvnaCategoryName.wheelsAndTires,
  CvnaCategoryName.brakingAndTraction,
  CvnaCategoryName.lighting,
  CvnaCategoryName.exterior
];

export enum FeatureTourHighlightCards {
  EvTaxCredit = 'Ev Tax Credit',
  LowMileage = 'Low Mileage',
  NoAccident = 'No Accident',
  SingleOwner = 'Single Owner',
  Warranty = 'Warranty'
}

type IconAsset = `/svgs/cvna-category/${string}`;

export const categoryIconsDesktop: Record<CvnaCategoryName, IconAsset> = {
  [CvnaCategoryName.brakingAndTraction]: '/svgs/cvna-category/brake-56px.svg',
  [CvnaCategoryName.cargoAndTowing]: '/svgs/cvna-category/trailer-56px.svg',
  [CvnaCategoryName.comfortAndConvenience]:
    '/svgs/cvna-category/steering-wheel-56px.svg',
  [CvnaCategoryName.entertainmentAndTechnology]:
    '/svgs/cvna-category/bluetooth-56px.svg',
  [CvnaCategoryName.exterior]: '/svgs/cvna-category/sparkle-car-56px.svg',
  [CvnaCategoryName.lighting]: '/svgs/cvna-category/lightbulb-56px.svg',
  [CvnaCategoryName.performanceAndDrive]:
    '/svgs/cvna-category/pistons-56px.svg',
  [CvnaCategoryName.roofAndGlass]: '/svgs/cvna-category/windshield-56px.svg',
  [CvnaCategoryName.safetyAndSecurity]: '/svgs/cvna-category/seatbelt-56px.svg',
  [CvnaCategoryName.seatingAndInterior]:
    '/svgs/cvna-category/rear-seats-56px.svg',
  [CvnaCategoryName.wheelsAndTires]: '/svgs/cvna-category/tire-56px.svg'
};

export const categoryIconsMobile: Record<CvnaCategoryName, IconAsset> = {
  [CvnaCategoryName.brakingAndTraction]: '/svgs/cvna-category/brake-32px.svg',
  [CvnaCategoryName.cargoAndTowing]: '/svgs/cvna-category/trailer-32px.svg',
  [CvnaCategoryName.comfortAndConvenience]:
    '/svgs/cvna-category/steering-wheel-32px.svg',
  [CvnaCategoryName.entertainmentAndTechnology]:
    '/svgs/cvna-category/bluetooth-32px.svg',
  [CvnaCategoryName.exterior]: '/svgs/cvna-category/sparkle-car-32px.svg',
  [CvnaCategoryName.lighting]: '/svgs/cvna-category/lightbulb-32px.svg',
  [CvnaCategoryName.performanceAndDrive]:
    '/svgs/cvna-category/pistons-32px.svg',
  [CvnaCategoryName.roofAndGlass]: '/svgs/cvna-category/windshield-32px.svg',
  [CvnaCategoryName.safetyAndSecurity]: '/svgs/cvna-category/seatbelt-32px.svg',
  [CvnaCategoryName.seatingAndInterior]:
    '/svgs/cvna-category/rear-seats-32px.svg',
  [CvnaCategoryName.wheelsAndTires]: '/svgs/cvna-category/tire-32px.svg'
};
